















































































































































import { Component, Vue, Provide } from "vue-property-decorator";
import Base from "@/template/public/Base.vue";
import AppPrompt from "@/components/AppPrompt.vue";
import request from "@/api/tongliang/index";
import native from "@/common/Native";
import { Toast, List, PullRefresh, Dialog, Loading } from "vant";
// import Zan from "@/components/Zan.vue";
import NewsItem from "@/components/NewsItemJLP.vue";
import { IShareConfig, ICommentItem } from "@/api/types";
import { wxChatShare } from "@/common/wechat";
import Openapp from "@/components/openApp.vue";
import CommentItem from "@/components/CommentItemJLP.vue";
import { Base64 } from "js-base64";
import { setImgSrc } from "@/common/Utils";
import nopage from "@/components/404.vue";
import ImageViewCom from "@/components/imageViewCom.vue";
import { getData, time } from "@/common/dataCollect";
@Component({
  components: {
    VanList: List,
    VanPullRefresh: PullRefresh,
    AppPrompt,
    VanLoading: Loading,
    Openapp,
    CommentItem,
    NewsItem,
    nopage,
    ImageViewCom
  }
})
export default class VideoPage extends Base {
  public request = new request();
  private commentList: ICommentItem[] = [];
  protected newsItem: any = {};
  private newsId?: number;

  private lastCreateTime: string = "";
  private lastReplyId?: number;

  private loading: boolean = false;
  private finished: boolean = false;
  private isLoading: boolean = false;
  private isOpenInApp: boolean = false;
  private businessDetail: any = {
    isPraised: "",
    viewCount: "",
    praiseCount: "",
    replyCount: ""
  };
  private userInfo: any = {
    appId: "",
    sessionId: "",
    token: ""
  };
  private isRequestLoaded: boolean = false; //详情是否加载完成
  public appId: string = "";
  private newsList: object[] = [];
  private isShowfalse: boolean = false; //404页面在数据未加载出来的时候也会显示, 加一层在数据加载完后的显示和隐藏

  vfrom: string = ""; //是否预览
  ImgSrcArr: any = [];
  // 埋点
  startTime: string = "";
  endTime: string = "";
  dataSource = true;
  created() {
    this.startTime = time();
  }
  mounted() {
    this.vfrom = (this.$route.query.vfrom as string) || "";
    this.infoClassifyId = this.$route.query.cid as string; // by zhanxin 新闻详情页统一用cid
    this.appId = (this.$route.query.appId as string) || "";

    (window as any).cq_callBack_reply = () => {
      this.onRefresh();
    };
    //九龙坡 预览新闻时, 底部评论和顶部分享不显示
    if (this.vfrom && ZWY_CLOUD.isOpenInApp()) {
      ZWY_CLOUD.topBarConfig({
        isShowTop: 1,
        isShowBackBtn: 1,
        isShowTitle: "",
        isShowMoreBtn: "0"
      });
      ZWY_CLOUD.bottomBarConfig({
        isShowBottom: 0,
        callBack_replyList: "releaseReplyList",
        praiseNum: 0,
        isPraised: 0
      });
    }
    if (native.isOpenInApp()) {
      this.isOpenInApp = true;
      native.getUserInfo().then((response: any) => {
        this.userInfo = response;
      });
    } else {
      this.isOpenInApp = false;
    }
    this.getNewsDetails().then(() => {
      // this.getComments();
      this.getBussinessDetail();
      this.getCount();
      this.getNewsList();
    });
  }
  getNewsDetails() {
    // this.isLoading = true;
    return this.request
      .getNewsDetails(this.infoClassifyId)
      .then(result => {
        this.isRequestLoaded = true;
        if (result.code == 0) {
          this.newsItem = result.data;
          this.newsId = result.data.id;
          document.title = this.newsItem.title;
          // 唤醒头部 赋值base.vue里detailGetAppId参数值
          this.getShareInfo(this.newsItem.appId);
          this.detailGetAppId = this.newsItem.appId;
          this.$nextTick(() => {
            setImgSrc(this.$refs.synopsisContent as Element);
            this.handleVideo();
            this.imageHandle(); // 图片预览等功能
            // 埋点
            this.endTime = time();
            if (this.dataSource) {
              getData(this.startTime, this.endTime, this.newsItem);
              this.dataSource = false;
            }
          });
        } else {
          this.$nextTick(() => {
            this.isShowfalse = true;
          });
        }
        this.isLoading = false;
      })
      .catch(() => {
        this.getShareInfo(this.appId);
        this.isRequestLoaded = true;
        this.isShowfalse = true;
      });
  }
  // 图片处理
  openViewChild(index: any) {
    const el = this.$refs.ImageViewCom as any;
    el.openView(index);
  }
  imageHandle() {
    const elements: Array<HTMLElement> = Array.prototype.slice.call(
      document.querySelectorAll(".synopsis-content img") as NodeListOf<
        HTMLElement
      >,
      0
    );
    const srcArr: Array<string> = elements.map(
      v => v.getAttribute("data-original") as string
    );
    this.ImgSrcArr = srcArr;
    let th = this;
    elements.forEach((v, i) => {
      (function(i) {
        v &&
          v.addEventListener(
            "click",
            function(e) {
              th.openViewChild(i);
            },
            false
          );
      })(i);
    });
  }
  getComments(isClear = true) {
    if (isClear) {
      // 如果要清除所有，重新加载，需要重置到第一页
      this.lastCreateTime = "";
      this.lastReplyId = undefined;
    }
    this.request
      .getCommentListPage(
        this.appId,
        this.userInfo.sessionId,
        this.newsItem.id,
        "1",
        this.lastCreateTime,
        this.lastReplyId,
        this.userInfo.token
      )
      .then(result => {
        if (isClear) {
          this.commentList = [];
        }
        if (result.data.dataList.length === 0) {
          this.finished = true;
        } else {
          this.commentList = this.commentList.concat(result.data.dataList);
          this.isLoading = false;
          this.loading = false;
          this.lastCreateTime = result.data.dataList.lastChild
            .createTime as string;
          this.lastReplyId = result.data.dataList.lastChild.replyId;
        }
        console.log(this.commentList);
      });
  }
  reply(item: ICommentItem) {
    if (this.isOpenInApp) {
      native.showNativeView("openCommentPage", "openCommentPage", {
        replyId: item.replyId + "",
        id: "",
        passiveReplyId: item.userId + "",
        passiveReplyName: item.userName
      });
    } else {
      Dialog.alert({
        message: "请前往下载" + this.shareInfo.appName + "客户端！",
        closeOnClickOverlay: true
      }).then(() => {
        // on close
        // obj.jumpToApp(this.shareJson.downloadUrl, this.shareJson);
        // window.location.href = this.downloadUrl;
        this.openApp(this.newsItem);
      });
    }
  }
  // getShareInfo() {
  //   this.request
  //     .getShareInfoMethod(this.appId)
  //     .then((response: IShareConfig) => {
  //       if (response.code >= 0) {
  //         this.shareInfo = response.data;
  //       }
  //     });
  // }
  onRefresh() {
    this.lastCreateTime = "";
    this.lastReplyId = undefined;
    this.finished = false;
    this.getNewsDetails().then(() => {
      this.getComments();
    });
  }
  goback() {
    window.history.back();
  }
  onLoad() {
    if (this.newsId) {
      this.getComments(false);
    }
  }
  /**业务详情 */
  getBussinessDetail() {
    this.request
      .getBussinessDetail(
        this.appId,
        this.userInfo.sessionId,
        // this.newsInfo.informationId,
        this.infoClassifyId,
        "1",
        this.userInfo.token
      )
      .then((response: any) => {
        if (response.code >= 0) {
          this.businessDetail = response.data;
          wxChatShare(
            response.data.detailTitle,
            response.data.shareDescription,
            response.data.shareUrlWx,
            response.data.shareImgUrl
          );
        }
      });
  }
  getCount() {
    // 在app外才需要增加浏览量 接口做了ua判断不需要前端判断是否在app内
    this.request.getCount(this.appId, this.infoClassifyId).then((res: any) => {
      if (res.code >= 0 && res.data) {
        this.businessDetail.viewCount = res.data.showViewCount;
        this.businessDetail.praiseCount = res.data.showPraiseCount;
        this.businessDetail.replyCount = res.data.showReplyCount;
      }
    });
  }

  /**热点列表 */
  getNewsList() {
    this.request
      .getHotListJLP(this.infoClassifyId, this.appId)
      .then(response => {
        if (response.code >= 0) {
          this.newsList = response.data.dataList;
        }
      });
  }
  //上万数字
  praiseNum(num: number) {
    if (num >= 10000) {
      return (num / 10000).toFixed(2) + "w";
    } else {
      return num;
    }
  }
  /****
   * 评论区方法
   */
  //图片预览
  toImagePreview(item: any) {
    if (native.isOpenInApp()) {
      native.viewImageContent({
        array: [
          {
            imgUrl: item.imageUrl,
            desc: ""
          }
        ],
        index: 0
      });
    } else {
      Dialog.alert({
        message: "请前往下载" + this.shareInfo.appName + "客户端！",
        closeOnClickOverlay: true
      }).then(() => {
        // on close
        // obj.jumpToApp(this.shareJson.downloadUrl, this.shareJson);
        // window.location.href = this.downloadUrl;
        this.openApp(this.newsItem);
      });
    }
  }
  /**到详情页 */
  toCommentDetail() {
    let param = {
      id: this.infoClassifyId,
      informationId: this.newsItem.informationId,
      sourceType: this.newsItem.sourceType,
      newsCommentType: this.newsItem.commentType
    };
    let jsonParam = {
      iOS: "CQCommentDetailController",
      Android: "goToFamous",
      par: param
    };
    if (native.isOpenInApp()) {
      native.pushToController(jsonParam);
    } else {
      Dialog.alert({
        message: "请前往下载" + this.shareInfo.appName + "客户端！",
        closeOnClickOverlay: true
      }).then(() => {
        // on close
        // obj.jumpToApp(this.shareJson.downloadUrl, this.shareJson);
        // window.location.href = this.downloadUrl;
        this.openApp(this.newsItem);
      });
    }
  }
  /**评论点赞 */
  doPraise(item: ICommentItem) {
    if (this.isOpenInApp) {
      this.request
        .doPraise(
          this.infoClassifyId,
          this.appId,
          this.userInfo.sessionId,
          item.replyId,
          1,
          "1",
          1,
          this.userInfo.token,
          new Date().getTime()
        )
        .then((response: any) => {
          if (response.code >= 0) {
            if (response.data) {
              this.getComments(true);
              //积分
              if (response.data.point && response.data.point > 0) {
                try {
                  ZWY_CLOUD.showPointView({
                    message: "点赞成功！",
                    point: response.data.point
                  });
                } catch (e) {
                  ZWY_CLOUD.appAlert({ message: "点赞成功！" });
                }
              } else {
                ZWY_CLOUD.appAlert({ message: "点赞成功！" });
              }
            }
          } else {
            ZWY_CLOUD.appAlert({ message: response.message });
          }
        })
        .catch((error: any) => {
          ZWY_CLOUD.appAlert({ message: error.toString() });
        });
    } else {
      Dialog.alert({
        message: "请前往下载" + this.shareInfo.appName + "客户端！",
        closeOnClickOverlay: true
      }).then(() => {
        // on close
        // obj.jumpToApp(this.shareJson.downloadUrl, this.shareJson);
        // window.location.href = this.downloadUrl;
        this.openApp(this.newsItem);
      });
    }
  }
  //点击查看更多
  domore() {
    Dialog.alert({
      message: "请前往下载" + this.shareInfo.appName + "客户端！",
      closeOnClickOverlay: true
    }).then(() => {
      this.openApp(this.newsItem);
    });
  }
  //跳转热点详情
  newItemClick(item: any) {
    if (native.isOpenInApp()) {
      native.openWebBrowser({
        id: item.id,
        sourceId: item.informationId,
        detailViewType: item.detailViewType,
        sourceType: item.sourceType,
        commentType: item.commentType,
        contextType: item.contextType,
        isShowTop: "1",
        isShowBottom: "1",
        isShowMore: "1",
        url: item.url,
        shareUrl: item.shareUrl,
        title: Base64.encode(item.title), //base 64
        synopsis: Base64.encode(item.synopsis), //base 64
        shareImgUrl: item.shareImgUrl,
        videoFormat: item.videoFormat ? item.videoFormat : ""
      });
    } else {
      window.location.href = item.url;
    }
  }
}
